import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import API from '../../../services/API'
import BigModal from '../../../components/Modals/BigModal'
import ExposureOutcomeChip from './ExposureOutcomeChip'
import ExemptionWizard from '../Assessment/ExemptionWizard'

// Surfaces this event's CQC-exposure assessment status on the event page
// (TopPanel), with a click-through to the exemption wizard - the
// highest-visibility entry point into the Registration & Regulatory
// Compliance module, since it appears wherever an event planner already is.
const EventExposureChip = ({ eventID }) => {
  const [outcome, setOutcome] = useState(null)
  const [open, setOpen] = useState(false)

  const load = () => {
    if (!eventID) return
    API.get(`/events/${eventID}/cqc-exposure`)
      .then((res) => {
        if (res.status === 200) {
          setOutcome(
            res.data.assessment?.status === 'completed' ? res.data.assessment.outcome : null,
          )
        }
      })
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    load()
  }, [eventID])

  if (!eventID) return null

  return (
    <>
      <Box onClick={() => setOpen(true)} sx={{ cursor: 'pointer' }}>
        <ExposureOutcomeChip
          outcome={outcome}
          {...(outcome ? {} : { label: 'CQC exposure: not assessed' })}
        />
      </Box>
      <BigModal
        open={open}
        onClose={() => {
          setOpen(false)
          load()
        }}
      >
        <Box sx={{ p: { xs: 1, md: 2 } }}>
          <Typography variant="h6" fontWeight={800} sx={{ mb: 2 }}>
            CQC Exposure Assessment
          </Typography>
          <ExemptionWizard eventID={eventID} embedded onAssessed={load} />
        </Box>
      </BigModal>
    </>
  )
}

export default EventExposureChip
